import React, { useEffect, useRef, useContext, useState } from 'react'

import { observer } from 'mobx-react-lite'
import UnpaidWagesSearch from './UnpaidWagesSearch'
import Conditional from '../common/Conditional'
import FormDependencyLoaderContext from '../context/FormDependencyLoaderContext'
import './UnpaidWages.css'
import UnpaidWagesPossibleMatch from './UnpaidWagesPossibleMatch'
import UnpaidWagesThankyou from './UnpaidWagesThankyou'

const UnpaidWagesMain = observer(() => {
  const loader = useContext(FormDependencyLoaderContext)
  const mountedRef = useRef(false)
  const [claim, setClaim] = useState({ step: 1, id: null })

  useEffect(() => {
    mountedRef.current = true
    loader.show()
    if (mountedRef.current) {
      setClaim((prevState) => ({
        ...prevState,
        step: 1,
        id: null,
      }))
      loader.hide()
    }
    return () => {
      mountedRef.current = false
    }
  }, [])

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      window.scroll(0, 0)
    }
    return () => {
      mountedRef.current = false
    }
  }, [claim.step])

  const move = (id: string) => {
    setClaim((prevState) => ({
      ...prevState,
      step: prevState.step + 1,
      id: id,
    }))
  }

  const renderForm = () => {
    switch (claim.step) {
      case 1:
        return (
          <>
            <UnpaidWagesSearch onSave={move} />
          </>
        )
      case 2:
        return (
          <>
            <UnpaidWagesPossibleMatch />
          </>
        )
      case 3:
        return (
          <>
            <UnpaidWagesThankyou />
          </>
        )
      default:
        return (
          <>
            <UnpaidWagesSearch onSave={move} />
          </>
        )
    }
  }

  return (
    <>
      <Conditional if={!loader.isLoading}>{renderForm()}</Conditional>
    </>
  )
})

export default UnpaidWagesMain
